import { render, staticRenderFns } from "./userOverview.vue?vue&type=template&id=fa58cad0&scoped=true"
import script from "./userOverview.vue?vue&type=script&lang=js"
export * from "./userOverview.vue?vue&type=script&lang=js"
import style0 from "./userOverview.vue?vue&type=style&index=0&id=fa58cad0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa58cad0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\CRMEB-JAVA-v2.4\\CRMEB-JAVA-v2.4\\single_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa58cad0')) {
      api.createRecord('fa58cad0', component.options)
    } else {
      api.reload('fa58cad0', component.options)
    }
    module.hot.accept("./userOverview.vue?vue&type=template&id=fa58cad0&scoped=true", function () {
      api.rerender('fa58cad0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/userOverview.vue"
export default component.exports